<template>
  <section v-on:click="sectionClicked" class="features">
    <div class="cnt">
      <div class="formCnt" :style="{'max-width': section.maxWidth}">
        <form v-on:submit.prevent="handleSubmit">
          <template v-if="section.items.length > 0">
            <div class="fieldGroup" v-for="(item, i) in section.items" :key="`f${i}`"
              :class="{hasError: item.error && item.error[lang]}">
              <label v-if="item.label && item.label[lang]">{{item.label[lang]}}
                <template v-if="item.isRequired">*</template></label>
              <div class="fieldCnt" v-if="['text', 'email', 'date'].includes(item.type)">
                <input :type="item.type" class="field"
                  :placeholder="item.type !== 'date' ? item.placeholder[lang] : ''"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null">
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'textarea'">
                <textarea class="field" :placeholder="item.placeholder[lang]" rows="3"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null"></textarea>
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'checkbox'">
                <div class="ckCnt" v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                  <label>
                    <input type="checkbox" v-model="opt.selected"
                      v-on:change="item.error[lang] = null">
                    <span class="checkmark"></span>
                    {{opt.label}}
                  </label>
                </div>
              </div>
              <div class="fieldCnt" v-else-if="['select', 'dropdown'].includes(item.type)">
                <select class="field" v-model="item.model[lang]"
                  v-on:change="item.error[lang] = null">
                  <option value="__placeholder__" v-if="item.placeholder[lang]">
                    {{item.placeholder[lang]}}
                  </option>
                  <option v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                    {{opt.label}}
                  </option>
                </select>
              </div>
              <div class="fieldError" v-if="item.error && item.error[lang]">
                {{item.error[lang]}}
              </div>
              <div class="fieldHint" v-if="item.hint && item.hint[lang]">
                {{item.hint[lang]}}
              </div>
            </div>
          </template>
          <button class="btn primary" type="submit">
            <span v-if="lang === 'en'">Submit</span>
            <span v-if="lang === 'id'">Kirimkan</span>
          </button>
        </form>
      </div>
    </div>
    <ThankYou ref="thankYou"/>
  </section>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'home',
  props: ['section', 'event'],
  components: { ThankYou },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    resetForm() {
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (['select', 'dropdown'].includes(item.type)) {
          item.model[this.lang] = '__placeholder__';
        } else if (item.type === 'checkbox') {
          // eslint-disable-next-line
          for (const opt of item.options) {
            opt.selected = false;
          }
        } else {
          item.model[this.lang] = '';
        }
      }
    },
    handleSubmit() {
      const formData = {
        title: this.section.title,
        descriptions: this.section.descriptions,
        emailVerification: this.section.emailVerification,
        lang: this.lang,
        items: [],
        confirmationForm: this.section.confirmationForm,
      };
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (item.isRequired) {
          if (['select', 'dropdown'].includes(item.type)) {
            if (!item.model[this.lang] || item.model[this.lang] === '__placeholder__') {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (item.type === 'checkbox') {
            let hasSelected = false;
            // eslint-disable-next-line
            for (const opt of item.options) {
              if (opt.selected) hasSelected = true;
            }
            if (!hasSelected) {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (!item.model[this.lang] || item.model[this.lang].trim() === '') {
            item.error.id = 'Masukan harus diisi';
            item.error.en = 'Field is required';
            return;
          }
        }

        formData.items.push({
          type: item.type,
          isRequired: item.isRequired,
          label: item.label[this.lang],
          model: item.model[this.lang],
          placeholder: item.placeholder[this.lang],
          options: item.options,
        });
      }
      this.$refs.thankYou.open({
        loading: true,
        title: this.section.thankYouTitle[this.lang],
        desc: this.section.thankYouDesc[this.lang],
      });
      this.$http.post(this.$config.uri(`invitation/${this.event.id}/guest`), formData).then((r) => {
        this.$refs.thankYou.stopLoading();
        this.resetForm();
      }).catch((err) => {
        this.$refs.thankYou.stopLoading();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    // eslint-disable-next-line
    for (const item of this.section.items) {
      if (['select', 'dropdown'].includes(item.type) && item.placeholder[this.lang]) {
        item.model[this.lang] = '__placeholder__';
      }
    }
  },
};
</script>

<style scoped lang="scss">
.formCnt{
  margin: 0 auto;
  text-align: left;
  .fieldGroup{
    label{
      text-transform: none;
      font-weight: normal;
      color: #444;
      &.noData{
        width: 120px;
        height: 16px;
        background-color: #eee;
        border-radius: 3px;
      }
    }
    .field{
      &.noData{
        height: 46px;
        background-color: #eee;
        border-color: #eee !important;
        box-shadow: none !important;
      }
    }
    .fieldCnt{
      position: relative;
      .ckCnt{
        display: block;
        label{
          text-transform: none;
          font-size: 16px;
          color: #444;
          font-weight: 500;
          display: inline-block;
          position: relative;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding-left: 40px;
          height: 36px;
          .checkmark{
            position: absolute;
            top: 50%; left: 0;
            height: 24px; width: 24px;
            transform: translateY(-50%);
            border: #ccc 2px solid;
            box-sizing: border-box;
            border-radius: 5px;
            transition: all .3s ease;
            &:after{
              content: "";
              position: absolute;
              display: none;
              left: 6px;
              top: 0px;
              width: 5px;
              height: 14px;
              border: solid white;
              border-width: 0 3px 3px 0;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
          &:hover{
            .checkmark{
              border-color: #008552;
            }
          }
          input{
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
            &:checked ~ .checkmark {
              background-color: #008552;
              border-color: #008552;
            }
            &:checked ~ .checkmark:after {
              display: block;
            }
          }
        }
      }
    }
    &.hasError{
      .fieldCnt{
        .ckCnt{
          label{
            .checkmark{
              border-color: red;
            }
          }
        }
      }
    }
  }
  .btn{
    width: 100%;
    display: block;
    font-size: 18px;
    font-weight: 500;
    padding: 14px 20px;
  }
}
</style>
